module.exports = __webpack_public_path__ + "static/img/Cherry_Circle.6b58e00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cherry_Circle.png
// module id = Fltq
// module chunks = 1